import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import BackIcon from "../../assets/icons/arrow-left.svg";
import { getDuonut } from "../../services/duonut";
import { convertLinkToDataUrl } from "../../utils";
import ImageList from "./ImageList";
import "./pdf.css";

export default function Pdf() {
  const imagesRef = useRef();
  const navigate = useNavigate();
  const { userActivities, selectedUserActivity } = useSelector((state) => state.userActivity);
  const [duonutThumbnails, setDuonutThumbnails] = useState([])
  const { id: duonutId } = useParams();

  // console.log(duonutId)

  const fetchDuonut = () => {
    getDuonut(duonutId, async (err, res) => {
      if (err) {
        console.log(err);
        navigate(-1)
        return
      }
      let thumbnails = []
      res.data.duonutthumbnail_set.map(thumbnail => {
        convertLinkToDataUrl(thumbnail.thumbnail, (result) => {
          if (!result) return;
          thumbnails.push({ uri: result });
          setDuonutThumbnails(prev => {
            return [...prev, { uri: result }]
          })
          // if(idx === res.data.duonutthumbnail_set.lenngth -1) return setDuonutThumbnails(thumbnails)
        })
      })
    });
  };

  useEffect(() => {
    if (duonutId) return fetchDuonut()
  }, [])

  const genPdf = () => {
    var HTML_Width = imagesRef.current.clientWidth;
    var HTML_Height = imagesRef.current.clientHeight;

    var top_left_margin = 15;
    var PDF_Width = HTML_Width + top_left_margin * 2;
    var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    var canvas_image_width = HTML_Width;
    var canvas_image_height = HTML_Height;

    var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    const input = document.getElementById("images-div");

    html2canvas(input, { allowTaint: true }).then(function (canvas) {
      canvas.getContext("2d");
      var imgData = canvas.toDataURL("image/jpeg", 1.0);

      var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
      pdf.addImage(imgData, "JPG", top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);

      for (var i = 1; i <= totalPDFPages; i++) {
        // pdf.addPage(PDF_Width, PDF_Height)
        pdf.addPage();
        pdf.addImage(imgData, "JPG", top_left_margin, -(PDF_Height * i) + top_left_margin * 4, canvas_image_width, canvas_image_height);
      }
      pdf.save("HTML-Document.pdf");
    });
  };

  const downloadImage = () => {
    const input = document.getElementsByClassName("image-div");

    // html2canvas(input, { allowTaint: true }).then(function (canvas) {
    //   canvas.getContext("2d");
    //   var imgData = canvas.toDataURL("image/jpeg", 1.0);
    //   var a = document.createElement("a"); //Create <a>
    //   // a.href = "data:image/png;base64," + imgData;
    //   a.href = imgData;
    //   a.download = "Image.png"; //File name Here
    //   a.click();
    // });
    let dataToMap = duonutId ? duonutThumbnails : userActivities

    for (let i = 0; i < dataToMap.length; i++) {
      html2canvas(input[i], {backgroundColor: "transparent"})
        .then(async (canvas) => {
          canvas.getContext("2d");
          var imgData = canvas.toDataURL("image/png", 1.0);
          var a = document.createElement("a")
          // a.href = "data:image/png;base64," + imgData;
          a.href = imgData;
          a.download = `activity-${i + 1}.png`;
          a.click();
          if (i === dataToMap.length - 1) return console.log('done')
        })
    }

  };
  const downloadImageJpeg = () => {
    const input = document.getElementsByClassName("image-div");

    // html2canvas(input, { allowTaint: true }).then(function (canvas) {
    //   canvas.getContext("2d");
    //   var imgData = canvas.toDataURL("image/jpeg", 1.0);
    //   var a = document.createElement("a"); //Create <a>
    //   // a.href = "data:image/png;base64," + imgData;
    //   a.href = imgData;
    //   a.download = "Image.png"; //File name Here
    //   a.click();
    // });
    let dataToMap = duonutId ? duonutThumbnails : userActivities

    for (let i = 0; i < dataToMap.length; i++) {
      html2canvas(input[i])
        .then(async (canvas) => {
          canvas.getContext("2d");
          // The brower will only convert to image/jpeg if its support jpeg format
          var imgData = canvas.toDataURL("image/jpeg", 1.0);
          var a = document.createElement("a")
          // a.href = "data:image/png;base64," + imgData;
          a.href = imgData;
          a.download = `activity-${i + 1}.jpeg`;
          a.click();
          if (i === dataToMap.length - 1) return console.log('done')
        })
    }
  }
  const downloadImageJpg = () => {
    const input = document.getElementsByClassName("image-div");

    // html2canvas(input, { allowTaint: true }).then(function (canvas) {
    //   canvas.getContext("2d");
    //   var imgData = canvas.toDataURL("image/jpeg", 1.0);
    //   var a = document.createElement("a"); //Create <a>
    //   // a.href = "data:image/png;base64," + imgData;
    //   a.href = imgData;
    //   a.download = "Image.png"; //File name Here
    //   a.click();
    // });
    console.log(input);
    let dataToMap = duonutId ? duonutThumbnails : userActivities

    for (let i = 0; i < dataToMap.length; i++) {
      html2canvas(input[i])
        .then(async (canvas) => {
          canvas.getContext("2d");
          // The brower will only convert to image/jpg if its support jpg format
          var imgData = canvas.toDataURL("image/jpeg", 1.0);
          var a = document.createElement("a")
          // a.href = "data:image/png;base64," + imgData;
          a.href = imgData;
          a.download = `activity-${i + 1}.jpg`;
          a.click();
          if (i === dataToMap.length - 1) return console.log('done')
        })
    }
  }

  const genPdfs = () => {
    // const pdf = new jsPDF();
    const pdf = new jsPDF('p', 'px', 'a4');
    const input = document.getElementsByClassName('image-div');

    const imgWidth = input[0].getBoundingClientRect().width;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let dataToMap = duonutId ? duonutThumbnails : userActivities

    for (let i = 0; i < dataToMap.length; i++) {
      html2canvas(input[i])
        .then(async (canvas) => {
          const widthRatio = pageWidth / canvas.width;
          const heightRatio = pageHeight / canvas.height;
          const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

          const canvasWidth = canvas.width * ratio;
          const canvasHeight = canvas.height * ratio;

          const marginX = (pageWidth - canvas.width) / 2;
          const marginY = (pageHeight - canvas.height) / 2;
          const imgData = await canvas.toDataURL('image/png');
          let imageX = imgWidth > 500 ? 33 : 68
          let imageY = imgWidth > 500 ? 80 : 60

          // pdf.addImage(imgData, 'JPEG', imageX, imageY);
          // pdf.addImage(imgData, 'JPEG', marginX, marginY, pageWidth - 20, canvas.height);

          const imgProps = pdf.getImageProperties(imgData);
          if (imgProps.width > 500) {
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 200, pdfWidth, pdfHeight);
          } else {
            const pdfWidth = pdf.internal.pageSize.getWidth() - 200;
            const pdfHeight = (imgProps.height * pdfWidth) / (imgProps.width);
            pdf.addImage(imgData, 'PNG', 100, 50, pdfWidth, pdfHeight);
          }

          if (i !== dataToMap.length - 1) pdf.addPage();
          if (i === dataToMap.length - 1) pdf.save(`duonuts.pdf`);
        }).catch(err => console.log(err))
    }
  }

  return (
    <div style={{ marginTop: "6rem" }} className="pdf-container">
      <div
        className="pdf-header">
        {/* <img src={BackIcon} className='back-icon' style={{width:" 20px"}} /> */}
        <span className="back-icon icon-button" onClick={() => navigate(-1)}>
          {" "}
          {`<`}{" "}
        </span>
        <button className="btn-primary" onClick={genPdfs}>
          Download pdf
        </button>
        <button className="btn-primary" onClick={downloadImage}>
          Download Png
        </button>
        <button className="btn-primary" onClick={downloadImageJpeg}>
          Download Jpeg
        </button>
        <button className="btn-primary" onClick={downloadImageJpg}>
          Download Jpg
        </button>

      </div>
      {!duonutId && <ImageList imagesRef={imagesRef} data={userActivities} isCurrentDuonut={true} />}
      {duonutId && <ImageList imagesRef={imagesRef} data={duonutThumbnails} isCurrentDuonut={false} />}
    </div>
  );
}
